import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

// Growth order actions
export const actions = prepActions(service);

// Growth order sagas
export const growthOrderListSagas = createController(service, actions);
